<div class="card no-print" style="padding-top: 50px;">
    <h3 class="text-center">ใช้ชื่อหรือ รหัสชาวไร่ ค้นหา แล้วคลิ๊กเลือก แล้วจึงโหลดข้อมูล และ ปริ้น</h3>
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4 text-center">
            <div class="input-group mb-3 no-print">
                <input type="text" class="form-control" placeholder="รหัสชาวไร่ 10 หลัก" [(ngModel)]="onecode" maxlength="10"
                list="fmlist">
                <datalist id="fmlist">
                    <option *ngFor="let item of fmlist">{{item.fmcode_b1}} {{item.fmname}}</option>
                </datalist>
                <button class="btn btn-success" (click)="Loaddata();">โหลดข้อมูลและปริ้น</button>
              </div>
        </div>
    </div>
  
</div>



<div class="card">
    
    <div class="card-body" style="font-family: 'Sarabun', sans-serif;">
        <div class="row">
            <div class="content col-12">
                <img src="../../../../assets/images/bsflogo.png">
                <h2>&nbsp;ใบตรวจเยี่ยมนักธุรกิจไร่อ้อยบุรีรัมย์</h2>
                <h3>&nbsp;&nbsp;ประจำปีการผลิต 2565/2566</h3>
            </div>
            <!-- <div class="col-8 text-center">
                
            </div> -->
        </div>
        <div class="row">
            <div class="col-md-12 text-center" *ngIf="onerow != null">
               <label>โควตา : {{onerow.fmcode_b1}} {{onerow.fmname}}  โซน {{onerow.SUPZONE}} นสส.{{onerow.SUPCODE}} {{onerow.SUPNAME}}</label> 
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ">
                <table class="table table-sm">
                    <thead class="table-secondary">
                        <th scope="col">#</th>
                        <th scope="col">ข้อมูลแปลง</th>
                        <th scope="col">ระเบิดดาน</th>
                        <th scope="col">พันธุ์อ้อย</th>
                        <th scope="col">ระยะร่อง</th>
                        <th scope="col">เคมี 1</th>
                        <th scope="col">เคมี 2</th>
                        <th scope="col">เคมี 3</th>
                        <th scope="col">อินทรีย์</th>
                        <th scope="col">โดโลไมท์</th>
                        <th scope="col">% งอก</th>
                        <th scope="col">วัชพืช</th>
                        <th scope="col">โรค/แมลง</th>  
                        <th scope="col">ประเมิน</th>
                        <th scope="col">ชร.ประเมิน</th>
                        <th scope="col">วันที่ล่าสุด</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of data; index as i"> 
                            <td>{{i+1}}</td>
                            <td>{{item.intlandno}} {{item.CaneTypeName}} {{item.landvalue}} ไร่  
                                รูท {{item.route}} โซน {{item.supzone}} อายุ  {{item.caneage}} วัน</td>
                            <td> {{item.hardSoilBlast_doc}}</td>
                            <td>{{item.seedname}}</td>
                            <td>{{item.Groove + item.ck_Groove}}</td>
                            <td>{{item.AmountFertilizerRound + item.Fertilizer1}}</td>
                            <td>{{item.AmountFertilizerRound2 + item.Fertilizer2}}</td>
                            <td>{{item.AmountFertilizerRound3 + item.Fertilizer3}}</td>
                            <td>{{item.AmountNaturalFertilizer + item.Natural}}</td>
                            
                            <td>{{item.AmountDolomite + item.Dolomite}}</td>
                            <td>{{item.lastGerminationPercent + item.Germination}}</td>
                            <td>{{item.lastweed_doc}}</td>
                            <td>{{item.lastDisease_doc}}</td>
                            <!-- ประเมิน นสส แล้วก็ ชาวไร่ -->
                            <td class="text-center">{{item.ton}}</td>
                            <td class="text-center">...........</td>
                            <td>{{item.lastupdate_th}}</td>
                        </tr>
                        <tr class="table-secondary text-bold" *ngIf="data != null">
                            <td></td>
                            <td>รวม {{data.length}} แปลง {{sunland|number}} ไร่</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-9">
                <label>หมายเหตุ ข้อแนะนำ วันที่จะดำเนินการปิดกิจกรรมแปลงแต่ละกิจกรรมและความต้องการปัจจัย(วงเงิน ปุ๋ย ยา เครื่องมือ อื่นๆ)</label>  <br>
                <label>.........................................................................................................................................
                    ...................................................................................................................................................... </label><br>
                <label>.........................................................................................................................................
                    ...................................................................................................................................................... </label><br>
                <label>.........................................................................................................................................
                    ...................................................................................................................................................... </label>
            </div>
            <div class="col-3"> <br>
               <label>ลงชื่อ ..................................... ชาวไร่</label>  <br>
               <label>ลงชื่อ ..................................... นักส่งเสริม</label>  <br>
               <label>ลงชื่อ ..................................... ผจก.โซน</label> 
            </div>
        </div>
        
    </div>
</div>
